import React from 'react';

const OPTIONEN = [
  { wert: 'kuerzung',      label: 'Den kompletten Bewerbungsprozess massiv verkürzen' },
  { wert: 'schneller',     label: 'In kürzerer Zeit deutlich mehr Stellen bewerben' },
  { wert: 'auffallen',     label: 'Endlich auffallen und mehr Einladungen erhalten' },
  { wert: 'praesentieren', label: 'Meine Fähigkeiten professioneller präsentieren' },
  { wert: 'passend',       label: 'Herausfinden, welche Jobs wirklich zu mir passen' },
  { wert: 'feedback',      label: 'Endlich ehrliches Feedback auf meine Anschreiben und Lebensläufe bekommen' },
  { wert: 'traumjob',      label: 'Meinen Traumjob finden und nicht mehr suchen müssen' },
];

const OPT_MAP = Object.fromEntries(OPTIONEN.map(o => [o.wert, o.label]));

const GRUPPEN = [
  { label: 'TEMPO',   werte: ['kuerzung', 'schneller'] },
  { label: 'WIRKUNG', werte: ['auffallen', 'praesentieren'] },
  { label: 'KLARHEIT', werte: ['passend', 'feedback'] },
  { label: 'ZIEL',    werte: ['traumjob'] },
];

export default function StepErwartung({ wert = [], onChange }) {
  const auswahl = Array.isArray(wert) ? wert : [];

  function toggle(w) {
    if (auswahl.includes(w)) {
      onChange(auswahl.filter(x => x !== w));
    } else {
      onChange([...auswahl, w]);
    }
  }

  let tileIdx = 0;
  return (
    <div className="ob-step-enter">
      {GRUPPEN.map((gruppe, gi) => (
        <div key={gi}>
          <div className="ob-group-label">{gruppe.label}</div>
          <div className="ob-erwartung-tiles">
            {gruppe.werte.map(w => {
              const aktiv = auswahl.includes(w);
              const delay = `${0.05 + tileIdx++ * 0.07}s`;
              return (
                <button
                  key={w}
                  type="button"
                  className={`ob-erwartung-tile ob-tile--animate${aktiv ? ' ob-erwartung-tile--aktiv' : ''}`}
                  style={{ animationDelay: delay }}
                  onClick={() => toggle(w)}
                >
                  <span className="ob-erwartung-tile__indicator">
                    {aktiv ? '•' : ''}
                  </span>
                  <span className="ob-erwartung-tile__text">{OPT_MAP[w]}</span>
                  {aktiv && <span className="ob-erwartung-tile__check">✓</span>}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
